import PropTypes from 'prop-types';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { Theme } from 'styles/theme';
import { ConfirmProvider } from 'contexts/ConfirmProvider';
import { InitializeProvider } from 'contexts/Initialize';
import { AuthenticationProvider } from 'contexts/Authentication';
import { QuestionProvider } from 'contexts/Question';

const AppProvider = ({ children }) => (
  <HelmetProvider>
    <ThemeProvider theme={Theme}>
      <CssBaseline />
      <ConfirmProvider>
        <AuthenticationProvider>
          <InitializeProvider>
            <QuestionProvider>
              {children}
            </QuestionProvider>
          </InitializeProvider>
        </AuthenticationProvider>
      </ConfirmProvider>
    </ThemeProvider>
  </HelmetProvider>
);

AppProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AppProvider;
